import { render } from "./UserNumberDialog.vue?vue&type=template&id=abd99e4c&scoped=true&lang=pug"
import script from "./UserNumberDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNumberDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserNumberDialog.vue?vue&type=style&index=0&id=abd99e4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abd99e4c"]])

export default __exports__